import axios from 'axios';
import { API_URL } from '@/config';
import { getRefreshToken, setAuthSession } from './authStorage';

let refreshPromise = null;
const REFRESH_RETRY_DELAYS_MS = [500, 1000];

function wait(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

export function isAccessTokenExpired(accessToken) {
  return !accessToken;
}

export function refreshAccessToken() {
  if (!refreshPromise) {
    const refreshToken = getRefreshToken();
    if (!refreshToken) {
      return Promise.reject(new Error('Missing refresh token'));
    }

    refreshPromise = retryRefreshToken(refreshToken)
      .then((response) => {
        setAuthSession(response.data);
        return response.data.accessToken;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
}

async function retryRefreshToken(refreshToken) {
  let lastError = null;

  for (let attempt = 0; attempt <= REFRESH_RETRY_DELAYS_MS.length; attempt += 1) {
    try {
      return await axios.post(`${API_URL}/auth/refresh`, { refreshToken });
    } catch (error) {
      lastError = error;
      const retryDelay = REFRESH_RETRY_DELAYS_MS[attempt];
      if (retryDelay === undefined) {
        break;
      }
      await wait(retryDelay);
    }
  }

  throw lastError;
}

export function getValidAccessToken(accessToken) {
  return Promise.resolve(accessToken || null);
}
